import { httpPost, httpDelete, httpGet, httpPut } from '../../../Util/http';
import { addAlert } from '../../../MsgNotify/msgNotifyActions';
import compress from '../../../Util/jic_compress';

import auth from '../../../Login/authService'


export const GET_IMAGES_REQUEST = 'GET_IMAGES_REQUEST';
export const getImagesRequest = () => {
	return {
		type: GET_IMAGES_REQUEST
	}
}

export const GET_IMAGES_SUCCESS = 'GET_IMAGES_SUCCESS'
export const getImagesSuccess = images => {
	return {
		type: GET_IMAGES_SUCCESS,
		images: images
	};
}

export const GET_IMAGES_FAILURE = 'GET_IMAGES_FAILURE'
export const getImagesFailure = () => {
	return {
		type: GET_IMAGES_FAILURE
	};
}

export const getImages = workplaceId => {
	var _url = process.env.REACT_APP_webApiEndPoint + 'api/file/workplace/' + workplaceId + '/photos';
	return dispatch => {
		dispatch(getImagesRequest())
		return httpGet(_url)
			.then(response => {
				return response.json();
			})
			.then(json => {
				dispatch(getImagesSuccess(json))
			})
			.catch((e) => {
				console.error(e)
				dispatch(getImagesFailure())
				dispatch(addAlert("Kunne ikke hente billeder"))
			})
	};
}

export const printImage = (url, creationDate, description) => {
	var _url = process.env.REACT_APP_webApiEndPoint + `api/file/workplace/dailyreport/photo?url=${url}&creationDate=${creationDate}&description=${description}&token=${auth.getToken()}`;
	window.open(_url, '_blank');
	return dispatch => {

	}
}

export const ADD_PICTURE = 'ADD_PICTURE'
export const addPicture = pic => {
	return {
		type: ADD_PICTURE,
		pic: pic
	};
}

export const UPDATE_PICTURE = 'UPDATE_PICTURE'
export const updatePicture = (pic, index) => {
	return {
		type: UPDATE_PICTURE,
		pic: pic,
		index: index
	};
}

const ERRORMSG = 'kunne ikke uploade billede, prøv igen';

function readFile(file, workplaceId) {
	const uploadURL = process.env.REACT_APP_webApiEndPoint + "api/file/workplace/" + workplaceId;
	return dispatch => {
		var reader = new FileReader();
		// Closure to capture the file information.
		reader.onload = (function () {
			return function (evt) {
				var image = new Image();
				// Closure to capture the img size.
				image.onload = function () {
					var compressed = compress(image, "image/jpeg", 1);
					var picToAdd = {
						original: compressed,
						thumbnail: compressed,
						description: null,
						creationDate: new Date(),
						id: null
					}
					httpPost(uploadURL, { fileContent: compressed.substr(23) })
						.then(response => response.json())
						.then(
							(id) => { picToAdd.id = id; dispatch(addPicture(picToAdd)) },
							() => dispatch(addAlert(ERRORMSG)));
				};
				image.src = evt.target.result;
			};
		})(file);
		// Read in the image file as a data URL.
		reader.readAsDataURL(file);
	}
}

export function onFilesSelected(files, workplaceId) {
	return dispatch => {
		for (var i = 0, len = files.length; i < len; i++) {
			dispatch(readFile(files[i], workplaceId))
		}
	}
}

export const UPDATE_DESCRIPTION = 'UPDATE_DESCRIPTION'
export const updateDescription = (index, text) => {
	return {
		type: UPDATE_DESCRIPTION,
		index: index,
		text: text
	};
}

export const updateDescriptionRequest = (index, imageId, text) => {
	var url = process.env.REACT_APP_webApiEndPoint + "api/file/" + imageId + "/description";
	return dispatch => {
		httpPut(url, { description: text })
			.then(
				() => dispatch(updateDescription(index, text)),
				() => dispatch(addAlert("kunne ikke opdatere bemærkning, prøv igen"))
			);
	}
}

export const updatePicRequest = (editedPic, index) => {
	var url = process.env.REACT_APP_webApiEndPoint + "api/file/" + editedPic.id;
	return dispatch => {
		httpPut(url, { fileContent: editedPic.original.substr(23) })
			.then(
				() => dispatch(updatePicture(editedPic, index)),
				() => dispatch(addAlert("kunne ikke opdatere billedet, prøv igen"))
			);
	}
}


export const SET_IS_SHOWING_DELETE_MODAL = 'SET_IS_SHOWING_DELETE_MODAL'
export const setIsShowingDeleteModal = (imageIndex) => {
	return {
		type: SET_IS_SHOWING_DELETE_MODAL,
		imageIndex
	};
}


export const DELETE_IMAGE_SUCCCESS = 'DELETE_IMAGE_SUCCCESS'
export const deleteImageSuccess = (imageIndex) => {
	return {
		type: DELETE_IMAGE_SUCCCESS,
		imageIndex
	};
}

export function attemptDeleteImage(imageIndex) {
	return (dispatch, getState) => {
		let currentImageId = getState().workplaceImagesReducer.pics[imageIndex].id;
		var _url = process.env.REACT_APP_webApiEndPoint + 'api/file/' + currentImageId
		return httpDelete(_url)
			.then(() => {
				dispatch(deleteImageSuccess(imageIndex))
			})
			.catch((e) => {
				dispatch(addAlert("Kunne ikke slette billedet"))
				console.error(e);
			})
	};
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Images/actions.js